import request from 'api'
import axios from 'axios'

type DeviceSignInInformation = {
  dateTime: string
  countryCode: string
}

export type DeviceResponse = {
  id: string
  deviceName: string
  deviceDisplayName: string
  modelCode: string
  modelName: string
  serialNumber: string
  type: string
  status: DeviceStatus
  signedIn: DeviceSignInInformation
  imei: string
  name: string
  imageUrl?: string
}

export interface Device extends DeviceResponse {
  lastSignedIn: {
    dateTime: string
    country: string
  }
}

type ProductResource = {
  modelName: string
  modelCode: string
  marketingName: string
  category: string
  images: Image[]
}

type Image = {
  url: string
  resolution: string
}

export enum DeviceStatus {
  ACTIVATED = 'ACTIVATED',
  REGISTERED = 'REGISTERED',
  SUSPENDED = 'SUSPENDED'
}

export enum ViewType {
  DETAIL = 1,
  REMOVE = 2
}

export const getDevicesApi = (confirmPasswordKey: string = '') => {
  return request
    .get<DeviceResponse[]>(`/devices`)
    .then((response) => {
      return response.data
    })
    .catch(() => {
      return [] as DeviceResponse[]
    })
}

export const getDeviceApi = (deviceId: string) => {
  return request.get<DeviceResponse>(`/v1/users/devices/${deviceId}`).then((response) => response.data)
}

export const signOutDeviceApi = (deviceId: string, confirmPasswordKey?: string) => {
  return request.delete(`/v1/users/devices/${deviceId}`, { headers: { 'x-confirm-key': confirmPasswordKey } })
}

export const getPki = (modelCode: string) => {
  if (!modelCode) {
    return Promise.reject(new Error('modelCode is required'))
  }

  return axios
    .get<ProductResource>(`${process.env.REACT_APP_PRODUCT_CATEGORY_URL}/${modelCode}.json`)
    .then((res) => res.data)
    .then((productResource) => productResource as ProductResource)
}
